export default __webpack_public_path__ + "static/media/ageGroup.91890244.svg";